var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscipline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0283 20.5L3 38.0506L12.9717 55.5L23 37.9494L13.0283 20.5Z",
    stroke: "#FAFAFA",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0372 37.9494L13 55.5H32.9609L43 37.9494M23.0372 37.9494H43M23.0372 37.9494L13.0567 20.5H33.0177L43 37.9494",
    stroke: "#FAFAFA",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9872 38L33 20.5515L43.044 3L53.0293 20.4504M42.9872 38L53.0293 20.4504M42.9872 38H62.9579L73 20.4504H53.0293",
    stroke: "#FAFAFA",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0864 3L53.0576 20.4504H73L63.0288 3H43.0864ZM43.0298 38L33 55.5496L42.9712 73L53.0009 55.4485L43.0298 38Z",
    stroke: "#FAFAFA",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0391 55.4485L43 73H62.9628L73 55.4485M53.0391 55.4485H73M53.0391 55.4485L43.0586 38H63.0195L73 55.4485",
    stroke: "#FAFAFA",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscipline);
export default __webpack_public_path__ + "static/media/discipline.e220d71c6db262b9a7ad794cf1525bdb.svg";
export { ForwardRef as ReactComponent };